const DEFAULT_HOOKS = ['activate', 'mount'];

export { DEFAULT_HOOKS };
//# sourceMappingURL=constants.js.map
